'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentYampiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.1473 22.0706H27.6833L30.5294 27.5975L33.3583 22.0706H36.8943L32.099 30.8722V35.5502H28.9425V30.8722L24.1473 22.0706Z",
          fill: "#503296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M38.9124 35.7408C38.2914 35.7408 37.7223 35.6369 37.2392 35.4289C36.7563 35.221 36.3768 34.8919 36.0836 34.4587C35.8076 34.0255 35.6696 33.4884 35.6696 32.83C35.6696 32.2756 35.7558 31.8078 35.9628 31.444C36.1526 31.0628 36.4285 30.7509 36.7563 30.5257C37.084 30.2831 37.4808 30.1098 37.9292 29.9886C38.3777 29.8673 38.8434 29.7807 39.3436 29.746C39.8956 29.694 40.3613 29.642 40.6891 29.5901C41.034 29.5381 41.2755 29.4514 41.4308 29.3302C41.586 29.2262 41.655 29.0703 41.655 28.8624V28.8277C41.655 28.4985 41.5342 28.2386 41.31 28.0654C41.0858 27.8921 40.7753 27.7881 40.3958 27.7881C39.9819 27.7881 39.6541 27.8748 39.3954 28.0654C39.1366 28.2386 38.9814 28.4985 38.9124 28.8104L36.0146 28.7064C36.1008 28.1001 36.3251 27.5629 36.67 27.0951C37.0323 26.6273 37.5153 26.2462 38.1534 25.9689C38.7744 25.6917 39.5334 25.5531 40.413 25.5531C41.034 25.5531 41.6205 25.6224 42.1552 25.7784C42.6899 25.9343 43.1384 26.1422 43.5351 26.4194C43.9319 26.6967 44.2251 27.0431 44.4493 27.459C44.6736 27.8748 44.777 28.3252 44.777 28.8624V35.6022H41.8275V34.2161H41.7757C41.6032 34.5453 41.379 34.8398 41.103 35.0651C40.827 35.2903 40.5166 35.4636 40.1543 35.5849C39.7749 35.6715 39.3609 35.7408 38.9124 35.7408ZM39.8783 33.6617C40.2233 33.6617 40.5166 33.5924 40.7925 33.4537C41.0685 33.3152 41.2755 33.1246 41.448 32.882C41.6032 32.6394 41.6894 32.3622 41.6894 32.033V31.0974C41.6032 31.1494 41.4998 31.1841 41.3617 31.2187C41.241 31.2534 41.103 31.288 40.9477 31.3226C40.7925 31.3573 40.6373 31.392 40.4821 31.4093C40.3268 31.4266 40.1715 31.4613 40.0163 31.4786C39.7231 31.5306 39.4643 31.5999 39.2574 31.7038C39.0504 31.8078 38.8951 31.9291 38.7744 32.085C38.6709 32.2409 38.6192 32.4315 38.6192 32.6394C38.6192 32.9686 38.7399 33.2112 38.9642 33.3845C39.2229 33.5751 39.5161 33.6617 39.8783 33.6617Z",
          fill: "#503296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M47.2264 35.5675V25.5357H50.2104V27.4762C50.4174 26.8699 50.8659 26.4021 51.3661 26.0555C51.8491 25.709 52.4355 25.5357 53.1083 25.5357C53.7982 25.5357 54.3847 25.709 54.8676 26.0728C55.3506 26.4194 55.6611 26.9045 55.7991 27.4936C55.9888 26.9045 56.4373 26.4367 56.972 26.0728C57.5067 25.7263 58.1277 25.5357 58.8694 25.5357C59.8009 25.5357 60.5598 25.8303 61.1463 26.4367C61.7328 27.0431 62.026 27.8574 62.026 28.897V35.5675H58.8867V29.6247C58.8867 29.1223 58.766 28.7584 58.5072 28.4985C58.2484 28.2386 57.9207 28.1 57.524 28.1C57.0927 28.1 56.7478 28.2386 56.5063 28.5158C56.2648 28.793 56.1441 29.1742 56.1441 29.642V35.5502H53.1255V29.5727C53.1255 29.1049 53.0048 28.7411 52.7633 28.4812C52.5218 28.2213 52.194 28.0827 51.7801 28.0827C51.5041 28.0827 51.2626 28.152 51.0556 28.2733C50.8487 28.4119 50.6761 28.5851 50.5727 28.8277C50.452 29.0702 50.4002 29.3475 50.4002 29.6767V35.5329L47.2264 35.5675Z",
          fill: "#503296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M64.3201 39.2753V25.5357H67.4249V27.355C67.5629 27.0605 67.8389 26.7659 68.0632 26.4887C68.3046 26.2115 68.5979 25.9862 68.9773 25.7956C69.3392 25.6224 69.7881 25.5357 70.3058 25.5357C70.9953 25.5357 71.634 25.709 72.2204 26.0728C72.824 26.4367 73.2894 26.9911 73.6688 27.7362C74.0311 28.4812 74.2209 29.4514 74.2209 30.6123C74.2209 31.7385 74.0483 32.6741 73.686 33.4364C73.3416 34.1987 72.8583 34.7532 72.2547 35.1343C71.6511 35.5155 70.9953 35.7061 70.2707 35.7061C69.7709 35.7061 69.3392 35.6195 68.9773 35.4636C68.6151 35.3076 68.3046 35.0824 68.0632 34.8225C67.8217 34.5626 67.6319 34.2681 67.4939 33.9562H67.4249V39.2753H64.3201ZM67.3904 30.6123C67.3904 31.1494 67.4594 31.6172 67.5974 31.9984C67.7354 32.3969 67.9424 32.7087 68.2184 32.9166C68.4943 33.1419 68.8221 33.2458 69.2017 33.2458C69.5812 33.2458 69.9084 33.1419 70.1848 32.9166C70.4605 32.6914 70.6502 32.3969 70.7884 31.9984C70.9266 31.5998 70.9953 31.132 70.9953 30.6123C70.9953 30.0752 70.9266 29.6247 70.7884 29.2262C70.6502 28.8277 70.4433 28.5332 70.1848 28.3252C69.9263 28.1173 69.5812 27.9961 69.2017 27.9961C68.8221 27.9961 68.4943 28.1 68.2184 28.3079C67.9424 28.5158 67.7354 28.8277 67.5974 29.2089C67.4767 29.6074 67.3904 30.0752 67.3904 30.6123Z",
          fill: "#503296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M78.0851 23.7165C77.6362 23.7165 77.2567 23.5606 76.9466 23.266C76.6359 22.9715 76.4806 22.6076 76.4806 22.1918C76.4806 21.776 76.6359 21.4295 76.9466 21.1349C77.2567 20.8404 77.6362 20.7018 78.0851 20.7018C78.5333 20.7018 78.9128 20.8577 79.2235 21.1349C79.5336 21.4295 79.6889 21.776 79.6889 22.1918C79.6889 22.6076 79.5336 22.9715 79.2235 23.266C78.8956 23.5606 78.5161 23.7165 78.0851 23.7165Z",
          fill: "#503296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M79.6374 25.5704H76.4977V35.5675H79.6374V25.5704Z",
          fill: "#503296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.1433 35.6021C15.954 35.6021 16.6957 35.3769 17.3511 34.9784C17.6961 34.372 17.8859 33.6616 17.8859 32.8993C17.8859 30.5776 16.0057 28.6891 13.6943 28.6891H11.383V26.4367C11.383 24.115 9.50287 22.2264 7.19151 22.2264C6.4153 22.2264 5.6736 22.4344 5.05263 22.8156C4.70766 23.4392 4.50067 24.1496 4.50067 24.912V31.184C4.50067 33.5057 6.5533 35.6021 8.86466 35.6021H15.1433Z",
          fill: "#FA3296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.1433 35.6022H8.86465C6.55329 35.6022 4.50066 33.5057 4.50066 31.184V24.912C4.50066 24.1497 4.70765 23.4393 5.05262 22.8156C3.82795 23.5432 3 24.8947 3 26.4367V32.3968C3 34.7185 5.32861 37.1268 7.63997 37.1268H13.6943C15.264 37.1268 16.6267 36.2605 17.3511 34.9784C16.6957 35.3769 15.9368 35.6022 15.1433 35.6022Z",
          fill: "#503296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.6957 34.0774H10.0203C7.70896 34.0774 6.00131 32.5701 6.00131 29.8672V23.3874C6.00131 22.6076 6.2083 21.88 6.58777 21.2562C5.3286 21.9839 4.4834 23.3526 4.4834 24.912V31.184C4.4834 33.5057 6.53603 35.6022 8.84739 35.6022H15.126C16.6784 35.6022 18.0411 34.7705 18.7828 33.523C18.1791 33.8696 17.4719 34.0774 16.6957 34.0774Z",
          fill: "#C83296"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3866 31.2014C19.2831 28.949 17.4547 27.1644 15.1951 27.1644H12.8837V24.9641C12.8837 22.5557 10.9001 20.5979 8.50246 20.7018C7.01906 20.7711 5.74263 21.6028 5.05267 22.8156C5.67364 22.4344 6.41534 22.2265 7.19155 22.2265C9.5029 22.2265 11.383 24.1151 11.383 26.4368V28.6892H13.6944C16.0058 28.6892 17.8859 30.5777 17.8859 32.8994C17.8859 33.6444 17.6962 34.3548 17.3512 34.9784C18.6104 34.2161 19.4383 32.7954 19.3866 31.2014Z",
          fill: "#FA78B4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.6957 25.6571H14.3843V23.4047C14.3843 21.083 12.5042 19.1945 10.1928 19.1945C8.65766 19.1945 7.31224 20.0261 6.57054 21.2736C7.13976 20.9444 7.79522 20.7365 8.48517 20.7018C10.8828 20.5979 12.8664 22.5557 12.8664 24.964V27.1644H15.1778C17.4374 27.1644 19.2658 28.949 19.3693 31.2014C19.4038 32.0504 19.1795 32.8473 18.7828 33.523C20.042 32.7954 20.8872 31.4266 20.8872 29.8673C20.8872 27.5283 19.0243 25.6571 16.6957 25.6571Z",
          fill: "#FAA0C8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.13935 22.3478C6.24285 21.9493 6.39809 21.5854 6.58783 21.2562C5.94962 21.6201 5.4149 22.1572 5.05267 22.8156C5.3804 22.6076 5.74263 22.4517 6.13935 22.3478Z",
          fill: "#FAA0C8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.7479 33.9389C17.6616 34.3027 17.5064 34.6493 17.3339 34.9784C17.9377 34.6146 18.4378 34.1121 18.7829 33.5231C18.4724 33.7137 18.1274 33.8522 17.7479 33.9389Z",
          fill: "#FAA0C8"
        }
      )
    ]
  }
);
const VpPaymentYampiAsset = forwardRef(PaymentYampiAsset);

export { VpPaymentYampiAsset as default };
